module.exports = __webpack_public_path__ + "static/GavulaXMas--2019-5eab654a35aae03f17da06fe85e5a383.pdf";